import type { FormFieldProps } from "@octopusdeploy/design-system-octopus-components";
import type { TagSetResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import type { DoBusyTask } from "~/components/DataBaseComponent/DataBaseComponent";
import * as tagSets from "~/components/tagSets";
import { TagMultiSelect } from "./TagMultiSelect";
interface ProjectTagMultiSelectionProps extends FormFieldProps<string[]> {
    doBusyTask: DoBusyTask;
    items?: TagSetResource[] | (() => TagSetResource[]);
    autoFocus?: boolean;
}
export class ProjectTagMultiSelect extends React.Component<ProjectTagMultiSelectionProps> {
    render() {
        return <TagMultiSelect {...this.props} getAll={() => tagSets.getAllByScopes(["Project"])} groupByTagSet={tagSets.groupByTagSet} flattenGroup={tagSets.flattenGroup}/>;
    }
    static displayName = "ProjectTagMultiSelect";
}
